import React, { Component } from "react";
import SubmitFeed from "./Elements/SubmitFeed";
import { isAppleSafari, showAddAccountAlertNew, TOAST_ERROR, isAccountConnected } from "../../../../../../../../../utils";
import SearchPlace from "../../../../../../Feeds/AddFeeds/Googlereviews/searchPlace";
import { toast } from "react-toastify";
import { MediaBaseUrl } from "../../../../../../../../../actions/api";
import GoogleTab from "../../../../../../Feeds/AddFeeds/Googlereviews/googleTab";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";
import { connect } from 'react-redux';
import { getConnectedAccount } from "../../../../../../../../../actions/addFeedActions";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class GoogleFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            feedText: "",
            placeName: null,
            placeId: null,
            error: false,
            connetedAccount: 0,
            accountChild: 0,
            otherAccount: false,
            loading: false
        }
    }

    onFieldTextChange = (text, id, placeName) => this.setState({ feedText: text, placeId: id, placeName: placeName, error: false })
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value })
    onAccountChildChange = (value) => this.setState({ accountChild: value })
    onotherAccount = (value) => this.setState({ otherAccount: value })

    onSubmit = (isDisabledClick) => {
        const { feedText, placeId, accountChild, connetedAccount } = this.state;
        const { selectedFilterId, connectedAcc } = this.props;

        const isAccConnected = isAccountConnected({ connectedAcc });

        if (selectedFilterId == 33) {
            if (!feedText.trim()) {
                this.setState({ error: true });
                if (isDisabledClick) {
                    TOAST_ERROR('Please enter an address to collect content');
                }
                return;
            }
            if (placeId == null) {
                TOAST_ERROR('Please select an option');
                return;
            }
        } else {
            // My Places (filter 29) - Google account required
            if (!isAccConnected) {
                TOAST_ERROR('Please connect your Google Account to collect content from My Places');
                return;
            }
            if (connetedAccount == 0) {
                TOAST_ERROR('Please select a connected Google account');
                return;
            }
            if (!accountChild) {
                TOAST_ERROR('Please select a Google location profile to proceed');
                return;
            }
        }

        this.onAddFeed();
    }


    onAddAccount = () => {
        toast.info("Please connect your Google Account to proceed", { autoClose: 3000 });
        showAddAccountAlertNew({ id: 4, name: "google" }, "addFeed");
    }


    onAddFeed = () => {
        const { placeName, feedText, placeId, connetedAccount, accountChild } = this.state
        const { selectedFilterId, updateStep } = this.props;

        var obj = {
            networkId: 4,
            filter: selectedFilterId,
            moderation: 0,
            connetedAccount: 0,
            account: 0
        }
        if (selectedFilterId == 33) {
            obj['field33'] = feedText;
            obj['field33placeId'] = placeId
            obj['field33placeName'] = placeName
        } else if (selectedFilterId == 29) {
            obj['field33'] = '';
            obj['field33placeId'] = '';
            obj['field33placeName'] = '';
            obj['connetedAccount'] = connetedAccount;
            obj['account'] = accountChild;
        }

        this.setState({ error: false, loading: true });
        
        updateStep(2, obj, () => this.setState({ loading: false }));

    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId,type } = response;
        if (type == "addFeed") {
          addUserAccount(networkId, data, () => this.props.getConnectedAccount(networkId),localStorage.getItem('ownerId'));
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { feedText, error, loading, connetedAccount, otherAccount, accountChild } = this.state;
        const { selectedFilterId, connectedAcc } = this.props;

        const childAcc = connectedAcc && connectedAcc[0] && connectedAcc[0].ConnectedAccounts && connectedAcc[0].ConnectedAccounts.child && connectedAcc[0].ConnectedAccounts.child.length ? connectedAcc[0].ConnectedAccounts.child : '';

        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 33 ? <div className="selectSource-right mb-5">
                    <div className="advance-input">
                        <SearchPlace onFieldTextChange={this.onFieldTextChange} setAddress={(e) => this.setState({ feedText: e, error: false })} address={feedText} />
                    </div>
                    {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                </div> :
                    (connectedAcc && connectedAcc.length > 0) ?
                        <div className="w-100 px-3">
                            <GoogleTab
                            onAddAccount={this.onAddAccount}
                            connectedAcc={connectedAcc}
                            otherAccount={otherAccount}
                            connetedAccount={connetedAccount}
                            accountChild={accountChild}
                            onotherAccount={this.onotherAccount}
                            onAccountChildChange={this.onAccountChildChange}
                            onConnectedAccountChange={this.onConnectedAccountChange}
                            childAcc={childAcc}
                        />
                        </div> : <div className="otherSection text-start">
                            <div className="py-2">
                                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3 cursor-pointer" onClick={this.onAddAccount}>
                                    <span className="symbol symbol-25 me-3">
                                        <img src={`${MediaBaseUrl}social-icons/google.svg`} alt="" />
                                    </span>
                                    <span className="text-dark-50 font-weight-bolder font-size-base" onClick={this.onAddAccount}>Connect Google</span>
                                </a>
                            </div>
                        </div>
                }
                {!otherAccount ? <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 33 ? !feedText.trim() : false} />
                </div> : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getConnectedAccount: (networkId) => dispatch(getConnectedAccount(networkId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleFeed)